module.exports = " {{getStrRes('ML_MachineVideo')}}: <a :href=link target=_blank> <img src=/assets/img/icon/video.png> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoLink.vue
// module id = 135
// module chunks = 0